import { useKeydown } from '@btime/react-hooks'
import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { Fixed } from '../helpers/Position'
import { hasValue } from '../../../../utils/helpers/value'
import { useMultiSelectState } from './MultiSelectHandler'
import Center from '../helpers/Center'
import Icon from '../shapes/Icon'
import Line from '../helpers/Line'
import Link from '../actions/Link'
import LoadingWrapper from '../helpers/LoadingWrapper'
import Panel from '../structure/Panel'
import Separator from '../helpers/Separator'
import Text, { SmallText } from '../presentation/Text'

const MultiSelectMenu = ({ options, loading }) => {
  const wrapperRef = React.useRef()
  const { selecteds, clearSelection } = useMultiSelectState()
  useKeydown(wrapperRef, { keys: ['Escape'], action: clearSelection })
  if (!hasValue(options) || !selecteds?.length) return false

  return (
    <div className="multiSelectMenu" ref={wrapperRef}>
      <Fixed bottom={0} left="50%" right="50%">
        <Center>
          <Panel bgColor="dark1" minWidth={68} noBorder noRadiusBottom padding={1}>
            <Grid gap={0.2} align="center" justify="space-between">
              <Col flex={1}>
                <Text size="p" color="white" bold>
                  {selecteds.length} item(s) selectionado(s)
                </Text>
              </Col>

              <LoadingWrapper loading={loading}>
                {options.map(({ label, value, icon, onClick, color }) => (
                  <Col flex={0} key={(label || value) + icon} minWidth={4}>
                    <Link onClick={onClick}>
                      <Center direction="column">
                        <Icon name={icon} color={color || 'white'} size={1.1} />
                        <Separator weight={1.5} />
                        <SmallText color={color || 'white'} size="xxsmall" bold align="center">
                          {label || value}
                        </SmallText>
                      </Center>
                    </Link>
                  </Col>
                ))}
              </LoadingWrapper>

              <Col flex={0} minWidth={0.1}>
                <Line vertical color="dark4" height={2.5} />
              </Col>

              <Col flex={0} minWidth={4}>
                <Link onClick={clearSelection}>
                  <Center direction="column">
                    <Icon name="BsX" color="white" size={1.4} />
                    <Separator weight={0.8} />
                    <SmallText color="white" size="xxsmall" bold>
                      Cancelar
                    </SmallText>
                  </Center>
                </Link>
              </Col>
            </Grid>
          </Panel>
        </Center>
      </Fixed>
    </div>
  )
}

export default MultiSelectMenu
